import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@metarouter-private/mr-mui';

/**
 * ReactDataTable.noDataComponent has 32px padding around the string that is passed in.
 * This mirrors that padding when using a custom noDataComponent react component (instead of a string)
 */
function NoDataText({ children }) {
  return (
    <Box p={4}>
      <Typography variant="body1">{children}</Typography>
    </Box>
  );
}

NoDataText.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NoDataText;
